import { Flyer } from "../types/flyers";
import api from "./api";

export const listFlyers = async (id: number): Promise<Flyer[]> => {
  const params = { offer_id: id };

  const response = await api.get("editor-prd/flyers", {
    params,
  });

  return response.data.content;
};
